export default "__VITE_ASSET__BpsMO4Ld__"